module.exports = __webpack_public_path__ + "static/img/katakana_large_da-compressor.c2eccc6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/katakana_large_da-compressor.gif
// module id = AK+j
// module chunks = 0